import { render, staticRenderFns } from "./OurTransportTransportationStagesBlock.vue?vue&type=template&id=2771cd02&scoped=true&"
import script from "./OurTransportTransportationStagesBlock.vue?vue&type=script&lang=js&"
export * from "./OurTransportTransportationStagesBlock.vue?vue&type=script&lang=js&"
import style0 from "./OurTransportTransportationStagesBlock.vue?vue&type=style&index=0&id=2771cd02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771cd02",
  null
  
)

export default component.exports